import Iframe from "react-iframe";

function AssessmentPage() {
  return (
    <div>
      {/* <Header /> */}
      <Iframe
        url="https://survey.alchemer.com/s3/7165302/8fa8322f3e19"
        width="100%"
        height="650px"
        display="inline"
        position="relative"
        sandbox={["allow-forms", "allow-scripts", "allow-same-origin"]}
        // styles={{ height: "100vh" }}
        styles={{ display: "block", height: "calc(100vh - 10px)" }}
      />
      {/* <Footer /> */}
    </div>
  );
}

export default AssessmentPage;
